import { UnavailableItemsByName } from '../../../redux/features/menuUnification/menuUnification.props';
import { UnavailabilityReason } from '../../../constants/brandMenu';
import { CartItem } from '../../../utils/cart';
import { sortModGroups } from '../../../utils/menu';
import {
  isBMItemConstraintNotAvailable,
  isBMItemNotSold,
} from '../../../utils/menuUnification.utils';
import { IModGroup } from './modGroup.props';

const hasModGroupChildren = (props: IModGroup) => {
  const { modGroup, cartModGroup, cartItem } = props;

  const modChildren = Object.values(cartModGroup?.selectedItems || {}).filter(
    (selectedModifierItem) => {
      const modGroupChildren = sortModGroups(
        modGroup.menuItems[selectedModifierItem.itemId]
      );
      const filteredModGroups = Object.values(modGroupChildren).filter(
        (mod) => !cartItem.modifierGroups[mod.id]
      );
      return filteredModGroups.length;
    }
  );

  return !!modChildren.length;
};

const canShowBMItem = ({
  unavailableItemsByName,
  itemName,
  cartItem,
  modGroupName,
}: {
  unavailableItemsByName: UnavailableItemsByName;
  itemName: string;
  cartItem: CartItem;
  modGroupName: string;
}) => {
  // If the item is globally not sold, hide it
  if (isBMItemNotSold(unavailableItemsByName, itemName)) {
    return false;
  }
  // If the item is not sold due to a constraint, hide it
  if (
    isBMItemConstraintNotAvailable({
      unavailableItemsByName,
      itemName,
      cartItem,
      constraintName: modGroupName,
      unavailabilityReason: UnavailabilityReason.notSold,
    })
  ) {
    return false;
  }
  // Otherwise, show the item
  return true;
};

/**
 * Determines if a menu item should be shown based on brand menu logic and item availability.
 */
const canShowItem = ({
  isBrandMenu,
  unavailableItemsByName,
  itemName,
  cartItem,
  modGroupName,
  childAvailability,
  is86edToday,
}: {
  isBrandMenu: boolean;
  unavailableItemsByName: UnavailableItemsByName;
  itemName: string;
  cartItem: CartItem;
  modGroupName: string;
  childAvailability: boolean;
  is86edToday: boolean;
}) => {
  if (isBrandMenu) {
    return canShowBMItem({
      unavailableItemsByName,
      itemName,
      cartItem,
      modGroupName,
    });
  }
  // For non-brand menu, show if available or 86ed today
  return !!(childAvailability || is86edToday);
};

// Shown instead of speaking the heading's description when express mode has
// suppressed this upsell prompt. A silently dead label would read as broken
// TTS and invite a second click, so say why the click did nothing (HITL-1529).
const EXPRESS_SUPPRESSED_LABEL_TOOLTIP =
  'Express mode is ON — this upsell is suppressed, so its description is not read out.';

export {
  hasModGroupChildren,
  canShowItem,
  canShowBMItem,
  EXPRESS_SUPPRESSED_LABEL_TOOLTIP,
};
